(() => {
  if (window.aquabossVideoInit) { window.aquabossVideoInit(); return; }
  const init = () => document.querySelectorAll('[data-aquaboss-hero]').forEach(hero => {
    if (hero.dataset.videoReady) return;
    hero.dataset.videoReady = 'true';
    const video = hero.querySelector('[data-hero-video]');
    const mobile = matchMedia('(max-width:700px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const fallback = () => { video.dataset.playing = 'false'; };
    const start = () => {
      if (!hero.isConnected) return;
      video.pause(); fallback();
      if (reduced.matches || navigator.connection?.saveData) {
        video.removeAttribute('src'); video.load(); return;
      }
      video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
      video.muted = true;
      video.play().catch(fallback);
    };
    video.addEventListener('playing', () => {
      video.dataset.playing = 'true';
    });
    video.addEventListener('error', fallback);
    mobile.addEventListener('change', start);
    reduced.addEventListener('change', start);
    start();
  });
  window.aquabossVideoInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
